import React from "react"
import {
    Close as ErrorIcon,
    Warning as WarningIcon,
    CheckCircle as SuccessIcon
} from "@mui/icons-material"
import { CircularProgress, Grid, Typography } from "@mui/material";
import { formattedDateToNumericPT } from '../../../utils/formatation'
import colors from '../../../resources/styles/css/colors'
import CircularProgressWithLabel from "../../CircularProgressWithLabel";

const SimulateInfo = ({ data }) => {

    const calculateRecovery = (questionCorrects, questionsErrors, questionNulls) => {
        const total = questionCorrects + questionsErrors + questionNulls;

        const recovery = (questionCorrects * 100) / total;

        return +recovery.toFixed(1);
    }

    const progressCircle = calculateRecovery(
        data.aproveitamento[0].questoesCorretas,
        data.aproveitamento[0].questoesErradas,
        data.aproveitamento[0].questoesNaoRespondidas
    )


    return (
        <Grid container spacing={2}>
            <Grid container item xs={12} direction="column" justifyContent="center" alignItems="center">            
                <CircularProgressWithLabel
                    size={'90px'}
                    variant="determinate"                    
                    color="primary"
                    value={progressCircle}                    
                />
            
                <Typography
                    variant="span"
                    color="primary"
                    align="center"
                    sx={{
                        fontSize: '24px',
                        fontWeight: '900',
                        marginTop: '10px',
                        fontColor: colors.palette.primary
                    }}
                >
                    {data.tipo.tipo}
                </Typography>

                <Typography
                    variant="caption"
                    align="center"
                    sx={{
                        fontSize: '17px'
                    }}
                >
                    {formattedDateToNumericPT(data.termino)}
                </Typography>
            </Grid>

            <Grid container item xs={12} justifyContent="space-evenly" alignItems="center" spacing={2} mb="10px">
                <Grid container item xs={4} direction="column" justifyContent="center" alignItems="center">
                    <ErrorIcon
                        style={{
                            color: colors.palette.error
                        }}
                    />

                    <Typography
                        color="error"
                        align="center"
                        sx={{
                            fontSize: '16px',
                            fontWeight: '900'
                        }}
                    >
                        {data.aproveitamento[0].questoesErradas}
                    </Typography>

                    <Typography
                        color="error"
                        align="center"
                        sx={{
                            fontSize: '16px',
                            fontWeight: '900'
                        }}>
                        {data.aproveitamento[0] > 1 ? "Erradas" : "Errada"}
                    </Typography>

                </Grid>
                <Grid container item xs={4} direction="column" justifyContent="center" alignItems="center">
                    <SuccessIcon
                        style={{
                            color: colors.palette.confirm
                        }}
                    />

                    <Typography
                        align="center"
                        sx={{
                            color: colors.palette.confirm,
                            fontSize: '16px',
                            fontWeight: '900'
                        }}>
                        {data.aproveitamento[0].questoesCorretas}
                    </Typography>

                    <Typography
                        align="center"
                        sx={{
                            color: colors.palette.confirm,
                            fontSize: '16px',
                            fontWeight: '900'
                        }}>
                        {data.aproveitamento[0] > 1 ? "Corretas" : "Correta"}
                    </Typography>
                </Grid>
                <Grid container item xs={4} direction="column" justifyContent="center" alignItems="center">
                    <WarningIcon
                        style={{
                            color: colors.palette.warning
                        }}
                    />

                    <Typography
                        align="center"
                        sx={{
                            color: colors.palette.warning,
                            fontSize: '16px',
                            fontWeight: '900'
                        }}>
                        {data.aproveitamento[0].questoesNaoRespondidas}
                    </Typography>

                    <Typography
                        align="center"
                        sx={{
                            color: colors.palette.warning,
                            fontSize: '16px',
                            fontWeight: '900'
                        }}>
                        Em branco
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export { SimulateInfo }